import {DownloadedIndoorWorkout} from '../Models/DownloadedIndoorWorkout';
import {Stroke} from '../Models/Stroke';
import {WorkoutInterval} from '../Models/WorkoutInterval';
import {Power} from '../Domain/Power';

export function downloadedIndoorWorkoutToStrokes(downloadedIndoorWorkout: DownloadedIndoorWorkout): Stroke[] {
    return workoutIntervalsToStrokes(downloadedIndoorWorkout.workoutIntervals);
}

export function workoutIntervalsToStrokes(workoutIntervals: WorkoutInterval[]): Stroke[] {
    const strokes = workoutIntervals.reduce<Stroke[]>((acc, interval) => {
        return [...acc, ...interval.strokes];
    }, []);

    //If all strokes have zero power or null speed return empty list
    if (
        strokes.every((stroke) => stroke.power === null || stroke.power.equals(Power.zero()) || stroke.speed === null)
    ) {
        return [];
    }

    return strokes;
}
